import React from "react";
import { useSelector } from "react-redux";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { SearchBar } from "../SearchBox/SearchBar";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";

const CommodityModal = ({
  open,
  onClose,
  formData,
  errors,
  handleInputChange,
  onSave,
}) => {
  if (!open) return null;
  //  const [formData, setFormData] = useState();

  const { isAnimate } = useSelector((state) => state.toast);

  const { commodityGroupList, uomlist } = useSelector((state) => state.common);

  const inputClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-slate-800 w-[720px] rounded-md shadow-lg">
        {/* Header */}
        <div className="px-4 py-2 bg-sky-500 text-white font-medium rounded-t-md">
          Add/Modify Commodity Info
        </div>

        {/* Body */}
        {/* <div className="p-4 space-y-3 border border-slate-200 dark:border-slate-700"> */}
        <div className="p-4 space-y-3 bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800">
          {/* Commodity */}
          <div className="grid grid-cols-12 gap-2 items-center">
            <label className="col-span-3 text-xs font-medium">
              Commodity <span className="text-red-500">*</span>
            </label>
            <div className="col-span-9">
              <Input
                name="commodity"
                value={formData.commodity}
                onChange={handleInputChange}
                className={inputClass}
              />
              {errors?.commodity && (
                <span className="text-red-500 text-[11px]">
                  {errors?.commodity}
                </span>
              )}
            </div>
          </div>

          {/* Schedule B & HTS */}
          <div className="grid grid-cols-12 gap-2 items-center">
            <label className="col-span-3 text-xs font-medium">
              Schedule B <span className="text-red-500">*</span>
            </label>
            <div className="col-span-3">
              <Input
                name="scheduleB"
                className={inputClass}
                value={formData?.scheduleB}
                onChange={handleInputChange}
              />
              {errors?.scheduleB && (
                <span className="text-red-500 text-[11px]">
                  {errors?.scheduleB}
                </span>
              )}
            </div>

            <label className="col-span-3 text-xs font-medium text-right">
              HTS Number <span className="text-red-500">*</span>
            </label>
            <div className="col-span-3">
              {/* <Input name="htsNumber" className={inputClass} value={formData?.htsNumber}  onChange={handleInputChange}/> */}
              <SearchBar
                searchAPI={"v1/AutoSuggestion/GetHtsusCode?Prefix="}
                showResults={0}
                selectReacord={(d) => {
                  handleInputChange({
                    target: { name: "htsNumber", value: d?.[0] },
                  });
                  handleInputChange({
                    target: { name: "commodityDescription", value: d?.[1] },
                  });
                }}
                displayKey="htsNo"
                value={formData?.htsNumber}
              />
              {errors?.htsNumber && (
                <span className="text-red-500 text-[11px]">
                  {errors?.htsNumber}
                </span>
              )}
            </div>
          </div>

          {/* Description */}
          <div className="grid grid-cols-12 gap-2">
            <label className="col-span-3 text-xs font-medium">
              Description
            </label>
            <div className="col-span-9">
              {/* <textarea
              className="w-full p-2 border rounded-md text-sm"
              rows="3"
              name="description"
            /> */}

              <Textarea
                rows="6"
                value={formData?.commodityDescription}
                onChange={handleInputChange}
                name="commodityDescription"
                className={inputClass}
              />
            </div>
          </div>

          {/* UOM */}
          <div className="grid grid-cols-12 gap-2 items-center">
            <label className="col-span-3 text-xs font-medium">
              Primary UOM <span className="text-red-500">*</span>
            </label>
            <div className="col-span-3">
              <select
                className={inputClass}
                name="primaryUOM"
                value={formData?.primaryUOM}
                onChange={handleInputChange}
              >
                <option value="">select</option>
                {uomlist?.map((group, key) => (
                  <option key={key} value={group.id}>
                    {group.utype}
                  </option>
                ))}
              </select>
              {errors?.primaryUOM && (
                <span className="text-red-500 text-[11px]">
                  {errors?.primaryUOM}
                </span>
              )}
            </div>

            <label className="col-span-3 text-xs font-medium text-right">
              Secondary UOM
            </label>
            <div className="col-span-3">
              <select
                className={inputClass}
                name="secondaryUOM"
                value={formData?.secondaryUOM}
                onChange={handleInputChange}
              >
                <option value="">select</option>
                {uomlist?.map((group, key) => (
                  <option key={key} value={group.id}>
                    {group.utype}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Commodity Group */}
          <div className="grid grid-cols-12 gap-2 items-center">
            <label className="col-span-3 text-xs font-medium">
              Commodity Group
            </label>
            <div className="col-span-9">
              <select
                className={inputClass}
                name="commodityGroupId"
                value={formData?.commodityGroupID}
                onChange={handleInputChange}
              >
                {/* <option>SELECT Commodity Group</option> */}
                <option>select</option>
                {commodityGroupList?.map((group, key) => (
                  <option key={key} value={group.moveTypeId}>
                    {group.moveType}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Hazardous Checkbox */}
          <div className="flex items-center gap-2 text-xs text-red-600 font-medium">
            <input
              type="checkbox"
              name="hazCommodity"
              checked={formData?.hazCommodity ?? false}
              value={formData?.hazCommodity ?? false}
              onChange={(e) => {
                handleInputChange(e);
              }}
            />
            Hazardous Commodity Information
          </div>

          {formData?.hazCommodity && (
            <>
              {/* Hazardous Fields */}
              <div className="grid grid-cols-12 gap-2 items-center">
                <label className="col-span-3 text-xs font-medium">
                  UN Number <span className="text-red-500">*</span>
                </label>
                <div className="col-span-3">
                  <Input
                    name="unNumber"
                    className={inputClass}
                    value={formData?.unNumber}
                    onChange={handleInputChange}
                  />
                  {errors?.unNumber && (
                    <span className="text-red-500 text-[11px]">
                      {errors?.unNumber}
                    </span>
                  )}
                </div>

                <label className="col-span-3 text-xs font-medium text-right">
                  Class <span className="text-red-500">*</span>
                </label>
                <div className="col-span-3">
                  <Input
                    name="commodityClass"
                    className={inputClass}
                    value={formData?.commodityClass}
                    onChange={handleInputChange}
                  />
                  {errors?.commodityClass && (
                    <span className="text-red-500 text-[11px]">
                      {errors?.commodityClass}
                    </span>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-12 gap-2 items-center">
                <label className="col-span-3 text-xs font-medium">
                  IMDG Page Num.
                </label>
                <div className="col-span-3">
                  <Input
                    className={inputClass}
                    name="imdgPageNum"
                    value={formData?.imdgPageNum}
                    onChange={handleInputChange}
                  />
                </div>

                <label className="col-span-3 text-xs font-medium text-right">
                  Label
                </label>
                <div className="col-span-3">
                  <Input
                    className={inputClass}
                    name="commodityLable"
                    value={formData?.commodityLable}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 gap-2 items-center">
                <label className="col-span-3 text-xs font-medium">
                  Package Group
                </label>
                <div className="col-span-3">
                  <select
                    className={inputClass}
                    name="packageGroup"
                    value={formData?.packageGroup}
                    onChange={handleInputChange}
                  >
                    <option>SELECT</option>
                    <option value="I">I</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                  </select>
                </div>

                <label className="col-span-3 text-xs font-medium text-right">
                  D.O.T. Code
                </label>
                <div className="col-span-3">
                  <Input
                    className={inputClass}
                    name="dotCode"
                    value={formData?.dotCode}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Flashpoint */}
              <div className="grid grid-cols-12 gap-2 items-center">
                <label className="col-span-3 text-xs font-medium">
                  Flashpoint
                </label>
                <div className="col-span-3">
                  <Input
                    className={inputClass}
                    name="flashPoint"
                    value={formData?.flashPoint}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-span-6 flex items-center gap-4 text-xs">
                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      name="flashPointType"
                      value="0"
                      checked={formData?.flashPointType === "0"}
                      onChange={handleInputChange}
                    />{" "}
                    °F
                  </label>
                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      name="flashPointType"
                      value="1"
                      checked={formData?.flashPointType === "1"}
                      onChange={handleInputChange}
                    />{" "}
                    °C
                  </label>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-center gap-3 px-4 py-3 border-t">
          <CelebrationButton
            onClick={() => onSave()}
            label={"SAVE"}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
            icon={<></>}
            isSuccess={isAnimate}
          />
          <button
            onClick={onClose}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommodityModal;
